import Page from '@/components/page'
import type { InferGetServerSidePropsType } from 'next'
import { getFooter, graphQLClient } from 'src/lib/graphql-contentful-api'
import type { Document } from '@contentful/rich-text-types'
import PageMetadata from '@/components/metadata'
import { ComponentRenderer } from 'src/lib/rich-text-render-helpers'
import { graphql } from '.gql/gql'
import type { ServerSideProps } from '@/pages/index'

export const WritingLegendsAboutUsPage_Query = graphql(/* GraphQL */ `
  query WritingLegendsMarketingSiteAboutUsPage($id: String!, $locale: String) {
    writingLegendsMarketingSiteAboutUsPage(id: $id, locale: $locale) {
      sys {
        id
      }
      aboutUsText {
        json
      }
      seoPageTitle
      seoPageDescription
      seoKeywords
    }
  }
`)

export const getServerSideProps = async ({ query, req }: ServerSideProps) => {
  const [{ data: footerData }, { data: aboutUsData }] = await Promise.all([
    getFooter(query.locale),
    graphQLClient.query(WritingLegendsAboutUsPage_Query, {
      id: '50O26y43CKZcLo3Yecqe7D',
      locale: query.locale,
    }),
  ])

  if (
    !aboutUsData?.writingLegendsMarketingSiteAboutUsPage ||
    !footerData?.composeComponentWlFooterBlock
  ) {
    return { notFound: true }
  }

  return {
    props: {
      footerProps: footerData.composeComponentWlFooterBlock,
      aboutUsProps: aboutUsData.writingLegendsMarketingSiteAboutUsPage,
      country: query.country,
      domain: req.headers.host,
    },
  }
}

function AboutUs({
  footerProps,
  aboutUsProps,
  country,
  domain,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const { seoPageTitle, seoPageDescription, aboutUsText, seoKeywords } =
    aboutUsProps

  return (
    <>
      <PageMetadata
        description={seoPageDescription}
        keywords={seoKeywords}
        title={seoPageTitle}
      />
      <Page footerData={footerProps} country={country} domain={domain}>
        <ComponentRenderer
          classNames="content-container flex-col space-y-6 px-8 py-8 prose-h1:text-left"
          document={aboutUsText?.json as Document}
        />
      </Page>
    </>
  )
}

export default AboutUs
